export const Pages = {
  energy: "/eficiencia-energetica",
  contact:"contacto"
}
